import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { WhyChoose } from "@/components/site/WhyChoose";
import { Services } from "@/components/site/Services";
import { Quality } from "@/components/site/Quality";
import { Process } from "@/components/site/Process";
import { Projects } from "@/components/site/Projects";
import { Testimonials } from "@/components/site/Testimonials";
import { Stats } from "@/components/site/Stats";
import { ServiceArea } from "@/components/site/ServiceArea";
import { FooterCTA } from "@/components/site/FooterCTA";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-[#050505] text-white grain-fixed font-body"
    >
      <Header />
      <main>
        <Hero />
        <WhyChoose />
        <Services />
        <Quality />
        <Process />
        <Projects />
        <Testimonials />
        <Stats />
        <ServiceArea />
        <FooterCTA />
      </main>
      <FloatingWhatsApp />
    </div>
  );
}
